<div class="charge-summary text-left">
  <h2 class="mb-4 mt-1">
    <fa-icon class="mr-2 charg-icon" [icon]="faCreditCard"></fa-icon>{{ 'ChargeSummery' | translate }}
  </h2>

  <div *ngIf="vehicleReservationCaseRentalPeriodModel!=null && vehicleReservationCaseRentalPeriodModel.length>0">
    <section class="rental-time">
      <div class="selected-class-title mb-2">
        <fa-icon class="mr-2 selected-class-icon rounded-circle" [icon]="faCar"></fa-icon>
        {{ 'RentalTime' | translate }}
      </div>

      <ng-container *ngFor="let item of vehicleReservationCaseRentalPeriodModel">
        <div class="manual-charge-title"> {{item.durationUnitName}} {{'Rate' | translate}} | {{item.rentalUnitPrice}}
          {{currency}}</div>
        <ul class="list-group mb-4">
          <li class="list-group-item d-flex justify-content-between lh-condensed">
            <div>
              <h6 class="my-0">{{item.durationUnit| number : '1.2-2'}} {{item.durationUnitCode}} *
                {{item.rentalUnitPrice| number : '1.2-2'}} {{currency}}</h6>
            </div>
            <span>{{item.totalRentalPrice | number : '1.2-2'}} {{currency}}</span>
          </li>
        </ul>
      </ng-container>
      <ng-container
        *ngIf="campaignsReservationCaseModel!=null &&  campaignsReservationCaseModel.discountScopeID==discountScope.RentalPeriod">
        <div class="manual-charge-title"> {{campaignsReservationCaseModel.campaignName}}</div>
        <ul class="list-group mb-4">
          <li class="list-group-item d-flex justify-content-between lh-condensed">
            <div>
              <h6 class="my-0">{{(campaignsReservationCaseModel.discount) | number : '1.2-2'}}%</h6>
            </div>
            <span>{{( (campaignsReservationCaseModel.discount/100) * totalRentalPrice)| number : '1.2-2'}}
              {{currency}}</span>
          </li>
        </ul>
      </ng-container>
      <ng-container *ngIf="membershipModel!=null &&  membershipModel.discountScopeID==discountScope.RentalPeriod">
        <div class="manual-charge-title"> {{membershipModel.membershipName}}</div>
        <ul class="list-group mb-4">
          <li class="list-group-item d-flex justify-content-between lh-condensed">
            <div>
              <h6 class="my-0">{{(membershipModel.discountValue) | number : '1.2-2'}}%</h6>
            </div>
            <span>{{( (membershipModel.discountValue/100) * totalRentalPrice)| number : '1.2-2'}} {{currency}}</span>
          </li>
        </ul>
      </ng-container>
      <ng-container
        *ngIf="agencyEmployeeAllowedDiscountsModel!=null &&  agencyEmployeeAllowedDiscountsModel.discountScopeID==discountScope.RentalPeriod">
        <div class="manual-charge-title"> {{'AgentDiscount' | translate}}</div>
        <ul class="list-group mb-4">
          <li class="list-group-item d-flex justify-content-between lh-condensed">
            <div>
              <h6 class="my-0">{{(agencyEmployeeAllowedDiscountsModel.discountPercentage) | number : '1.2-2'}}%</h6>
            </div>
            <span>{{( (agencyEmployeeAllowedDiscountsModel.discountPercentage/100) * totalRentalPrice)| number :
              '1.2-2'}} {{currency}}</span>
          </li>
        </ul>
      </ng-container>
    </section>
  </div>

  <ng-container *ngFor="let additionalService of lstAdditionalServiceReservationCase">
    <container-element [ngSwitch]="additionalService.predefinedAdditionalServiceID">
      <!---Start Additional Driver-->
      <section class="rental-time" *ngSwitchCase="predefinedAdditionalServiceEnum.AdditionalDrivers ">
        <div
          *ngIf="f['s_' + additionalService.additionalServiceID+'_toggle']!=null&& f['s_' + additionalService.additionalServiceID+'_toggle'].value">
          <div class="selected-class-title mb-2">
            <fa-icon class="mr-2 selected-class-icon rounded-circle" [icon]="faCar"></fa-icon>
            {{additionalService.serviceName}}
          </div>
          <ul class="list-group mb-4">
            <li class="list-group-item d-flex justify-content-between lh-condensed">
              <div>
                <h6 class="my-0" *ngIf="additionalService.isPerDay">
                  {{f['s_' + additionalService.additionalServiceID].value}}x
                  {{durationInDays}}{{chargeSummary.durationUnit}} x
                  {{additionalService.unitPrice | number : '1.2-2'}} {{currency}}
                </h6>
                <h6 class="my-0" *ngIf="!additionalService.isPerDay">
                  {{f['s_' + additionalService.additionalServiceID].value}}x
                  {{additionalService.unitPrice | number : '1.2-2'}} {{currency}}
                </h6>
              </div>
              <!-- <span>{{(  f['s_' + additionalService.additionalServiceID].value*additionalService.unitPrice) }}{{currency}}</span> -->
              <!-- <span>{{calculatePriceMain(additionalService)}} {{currency}}</span> -->
              <span>{{f[formControlPrefix + additionalService.additionalServiceID+formControlTotalPostfix].value |
                number : '1.2-2'}}
                {{currency}}</span>
            </li>
          </ul>
        </div>
      </section>

      <!---Start Drivers-->
      <section class="rental-time" *ngSwitchCase="predefinedAdditionalServiceEnum.Drivers ">
        <div
          *ngIf="f['s_' + additionalService.additionalServiceID+'_toggle']!=null&& f['s_' + additionalService.additionalServiceID+'_toggle'].value">
          <div class="selected-class-title mb-2">
            <fa-icon class="mr-2 selected-class-icon rounded-circle" [icon]="faCar"></fa-icon>
            {{additionalService.serviceName}}
          </div>
          <ul class="list-group mb-4">
            <li class="list-group-item d-flex justify-content-between lh-condensed">
              <div>
                <!--                 <h6 class="my-0">
                    {{additionalService.unitPrice}}{{currency}}</h6> -->
                <h6>
                  {{durationInDays}} x
                  {{additionalService.unitPrice | number : '1.2-2'}} {{currency}}
                </h6>

              </div>
              <span>{{f[formControlPrefix + additionalService.additionalServiceID+formControlTotalPostfix].value |
                number : '1.2-2'}}
                {{currency}}</span>
            </li>
          </ul>
        </div>
      </section>

      <!---Start OneWayRentalService-->
      <section class="rental-time" *ngSwitchCase="predefinedAdditionalServiceEnum.OneWayRentalService ">
        <div
          *ngIf="f['s_' + additionalService.additionalServiceID+'_toggle']!=null&& f['s_' + additionalService.additionalServiceID+'_toggle'].value">
          <div *ngIf="f['s_' + additionalService.additionalServiceID].value['charge']!=null">
            <div class="selected-class-title mb-2">
              <fa-icon class="mr-2 selected-class-icon rounded-circle" [icon]="faCar"></fa-icon>
              {{additionalService.serviceName}}
            </div>
            <ul class="list-group mb-4">
              <li class="list-group-item d-flex justify-content-between lh-condensed">
                <div>
                  <h6 class="my-0">
                    {{f['s_' + additionalService.additionalServiceID].value['charge'] | number : '1.2-2' }} {{currency}}
                  </h6>
                </div>
                <span>{{f[formControlPrefix + additionalService.additionalServiceID+formControlTotalPostfix].value |
                  number : '1.2-2'}}
                  {{currency}}</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <!---Start Crossing Borders-->
      <section class="rental-time" *ngSwitchCase="predefinedAdditionalServiceEnum.CrossingBoarders">
        <div
          *ngIf="f['s_' + additionalService.additionalServiceID+'_toggle']!=null&& f['s_' + additionalService.additionalServiceID+'_toggle'].value">
          <div class="selected-class-title mb-2">
            <fa-icon class="mr-2 selected-class-icon rounded-circle" [icon]="faCar"></fa-icon>
            {{additionalService.serviceName}}
          </div>
          <ul class="list-group mb-4" *ngFor="let borderObj of getBorders(additionalService.additionalServiceID)">
            <li class="list-group-item d-flex justify-content-between lh-condensed">
              <div>
                <h6 class="my-0">
                  {{borderObj.borderPortName}}</h6>
              </div>
              <span *ngIf="!isFreeService(predefinedAdditionalServiceEnum.CrossingBoarders)">{{borderObj.charge | number : '1.2-2'}} {{currency}}</span>
              <span *ngIf="isFreeService(predefinedAdditionalServiceEnum.CrossingBoarders)">{{0 }} {{currency}}</span>
            </li>
          </ul>
          <!-- <ul class="list-group mb-4">
            <li class="list-group-item d-flex justify-content-between lh-condensed">
              <div>
                <h6 class="my-0">
                  Total</h6>
              </div>
              <span>{{f[formControlPrefix + additionalService.additionalServiceID+formControlTotalPostfix].value}}
                {{currency}}</span>
            </li>
          </ul> -->
        </div>
      </section>

      <!---Start  Agent Delivery Service-->
      <section class="rental-time" *ngSwitchCase="predefinedAdditionalServiceEnum.RentalDelivery">
        <div
          *ngIf="f['s_' + additionalService.additionalServiceID+'_toggle']!=null
          && f['s_' + additionalService.additionalServiceID+'_toggle'].value
          && f[formControlPrefix + additionalService.additionalServiceID]!=null
          ">
          <div class="selected-class-title mb-2">
            <fa-icon class="mr-2 selected-class-icon rounded-circle" [icon]="faCar"></fa-icon>
            {{additionalService.serviceName}}
          </div>

          <ul class="list-group mb-4"
            *ngIf="f[formControlPrefix + additionalService.additionalServiceID]!=null
            &&f[formControlPrefix + additionalService.additionalServiceID].value['PickUpToggle']">
            <li class="list-group-item d-flex justify-content-between lh-condensed">
              <div>
                <h6 class="my-0"> {{ 'PickupLocation' | translate }} </h6>
              </div>
              <ng-container *ngIf="isFreeService(predefinedAdditionalServiceEnum.RentalDelivery)" >
                <span >{{0 }} {{currency}}</span>
              </ng-container>
              <ng-container *ngIf="!isFreeService(predefinedAdditionalServiceEnum.RentalDelivery)">
                <span *ngIf="!additionalService.isPerDay">{{additionalService.pickupUnitPrice}} {{currency}}</span>
                <span *ngIf="additionalService.isPerDay">{{(additionalService.pickupUnitPrice*durationInDays)| number : '1.2-2'}} {{currency}}</span>
              </ng-container>

            </li>
          </ul>
          <ul class="list-group mb-4"
            *ngIf="f[formControlPrefix + additionalService.additionalServiceID]!=null
            &&f[formControlPrefix + additionalService.additionalServiceID].value['ReturnToggle']">
            <li class="list-group-item d-flex justify-content-between lh-condensed">
              <div>
                <h6 class="my-0">
                  {{ 'ReturnLocation' | translate }}</h6>
              </div>
              <ng-container *ngIf="isFreeService(predefinedAdditionalServiceEnum.RentalDelivery)" >
                <span >{{0 }} {{currency}}</span>
              </ng-container>
              <ng-container *ngIf="!isFreeService(predefinedAdditionalServiceEnum.RentalDelivery)">
                <span *ngIf="!additionalService.isPerDay">{{additionalService.returnUnitPrice}} {{currency}}</span>
                <span *ngIf="additionalService.isPerDay">{{(additionalService.returnUnitPrice*durationInDays)| number : '1.2-2'}} {{currency}}</span>
              </ng-container>

            </li>
          </ul>
          <!--<ul class="list-group mb-4">
            <li class="list-group-item d-flex justify-content-between lh-condensed">
              <div>
                <h6 class="my-0">
                  Total</h6>
              </div>
              <span>{{f[formControlPrefix + additionalService.additionalServiceID+formControlTotalPostfix].value}}
                {{currency}}</span>
            </li>
          </ul>-->
        </div>
      </section>

      <!--Start Custom Service-->
      <section class="rental-time" *ngSwitchDefault>
        <!--Is AddOn-->
        <div *ngIf="additionalService.isPhysicalAddon">
          <div
            *ngIf="f['s_' + additionalService.additionalServiceID+'_toggle']!=null&&f['s_' + additionalService.additionalServiceID+'_toggle'].value">
            <div class="selected-class-title mb-2">
              <fa-icon class="mr-2 selected-class-icon rounded-circle" [icon]="faCar"></fa-icon>
              {{additionalService.serviceName}}
            </div>
            <ul class="list-group mb-4">
              <li class="list-group-item d-flex justify-content-between lh-condensed">
                <div>
                  <h6 class="my-0" *ngIf="additionalService.isPerDay">
                    {{f['s_' + additionalService.additionalServiceID].value}}x
                    {{durationInDays}}{{chargeSummary.durationUnit}} x
                    {{additionalService.unitPrice | number : '1.2-2'}} {{currency}}
                  </h6>
                  <h6 class="my-0" *ngIf="!additionalService.isPerDay">
                    {{f['s_' + additionalService.additionalServiceID].value}}x
                    {{additionalService.unitPrice | number : '1.2-2'}} {{currency}}
                  </h6>
                </div>
                <!-- <span>{{(f['s_' + additionalService.additionalServiceID].value*additionalService.unitPrice) }}{{currency}}</span> -->
                <span>{{f[formControlPrefix + additionalService.additionalServiceID+formControlTotalPostfix].value |
                  number : '1.2-2'}}
                  {{currency}}</span>
              </li>
            </ul>
          </div>
        </div>

        <!--Is Not AddOn-->
        <div *ngIf="!additionalService.isPhysicalAddon">
          <div
            *ngIf="f['s_' + additionalService.additionalServiceID+'_toggle']!=null&& f['s_' + additionalService.additionalServiceID+'_toggle'].value">
            <div class="selected-class-title mb-2">
              <fa-icon class="mr-2 selected-class-icon rounded-circle" [icon]="faCar"></fa-icon>
              {{additionalService.serviceName}}
            </div>
            <ul class="list-group mb-4">
              <li class="list-group-item d-flex justify-content-between lh-condensed">
                <div>
                  <h6 class="my-0" *ngIf="additionalService.isPerDay">
                    {{durationInDays}}{{chargeSummary.durationUnit}} x {{additionalService.unitPrice | number :
                    '1.2-2'}} {{currency}}
                  </h6>
                  <h6 class="my-0" *ngIf="!additionalService.isPerDay">
                    {{additionalService.unitPrice | number : '1.2-2'}} {{currency}}
                  </h6>
                </div>
                <!-- <span>{{additionalService.unitPrice }}{{currency}}</span> -->
                <span>{{f[formControlPrefix + additionalService.additionalServiceID+formControlTotalPostfix].value |
                  number : '1.2-2'}}
                  {{currency}}</span>
              </li>
            </ul>
          </div>
        </div>

      </section>

    </container-element>
  </ng-container>


  <ng-container>


    <!--   <div class="selected-class-title" *ngIf="manualCharges!=null && manualCharges.length>0">
    <fa-icon class="mr-2 selected-class-icon rounded-circle" [icon]="faCar"></fa-icon>
    Manual Charges
  </div>
  <ul class="list-group mb-4" *ngFor="let item of manualCharges">
    <li class="list-group-item d-flex ">
      <div>
        <h6 class="my-0" >
          {{item.description}}
        </h6>
      </div>


    </li>
    <li class="list-group-item d-flex justify-content-between lh-condensed">
      <div>
        <h6 class="my-0" >
          Charge
        </h6>
      </div>
      <span>{{item.amount }}{{currency}}</span>

    </li>
  </ul> -->
    <div *ngIf="ezRent!=null && ezRent.length>0">
      <section class="rental-time">
        <div class="selected-class-title mb-2">
          <fa-icon class="mr-2 selected-class-icon rounded-circle" [icon]="faCar"></fa-icon>
          {{ 'EZRent' | translate }}
        </div>

        <ng-container *ngFor="let item of ezRent">
          <!--<div class="manual-charge-title"> {{item.description}}</div>-->
          <ul class="list-group mb-4">
            <li class="list-group-item d-flex justify-content-between lh-condensed">
              <div>
                <h6 class="my-0">{{ 'Charge' | translate }}</h6>
              </div>
              <span>{{item.unitPrice | number : '1.2-2'}} {{currency}}</span>
            </li>
          </ul>
        </ng-container>
      </section>
    </div>

    <!-- Damages -->
    <div *ngIf="lstDamages!=null && lstDamages.length>0">
      <section class="rental-time">
        <div class="selected-class-title mb-2">
          <fa-icon class="mr-2 selected-class-icon rounded-circle" [icon]="faCar"></fa-icon>
          {{ 'Damages' | translate }}
        </div>

        <!-- Damages -->
        <ng-container *ngFor="let item of lstDamages">
          <!--<div class="manual-charge-title"> {{item.description}}</div>-->
          <ul class="list-group mb-4">
            <li class="list-group-item d-flex justify-content-between lh-condensed">
              <div>
                <h6 class="my-0">Charge</h6>
              </div>
              <span>{{item.damageValue | number : '1.2-2'}} {{currency}}</span>
            </li>
          </ul>
        </ng-container>
      </section>
    </div>
    <!--End Damages-->

    <!-- Fines -->
    <div *ngIf="lstFines!=null && lstFines.length>0">
      <section class="rental-time">
        <div class="selected-class-title mb-2">
          <fa-icon class="mr-2 selected-class-icon rounded-circle" [icon]="faCar"></fa-icon>
          {{ 'Fines' | translate }}
        </div>


        <ng-container *ngFor="let item of lstFines">
          <!--<div class="manual-charge-title"> {{item.description}}</div>-->
          <ul class="list-group mb-4">
            <li class="list-group-item d-flex justify-content-between lh-condensed">
              <div>
                <h6 class="my-0">Charge</h6>
              </div>
              <span>{{item.amount | number : '1.2-2' }} {{currency}}</span>
            </li>
          </ul>
        </ng-container>
      </section>
    </div>
    <!--End Fines-->


    <!-- Accident -->
    <div *ngIf="lstAccident!=null && lstAccident.length>0">
      <section class="rental-time">
        <div class="selected-class-title mb-2">
          <fa-icon class="mr-2 selected-class-icon rounded-circle" [icon]="faCar"></fa-icon>
          {{ 'Accident' | translate }}
        </div>


        <ng-container *ngFor="let item of lstAccident">
          <!--<div class="manual-charge-title"> {{item.description}}</div>-->
          <ul class="list-group mb-4">
            <li class="list-group-item d-flex justify-content-between lh-condensed">
              <div>
                <h6 class="my-0">Charge</h6>
              </div>
              <span>{{item.liabilityAmount | number : '1.2-2'}} {{currency}}</span>
            </li>
          </ul>
        </ng-container>
      </section>
    </div>
    <!--End Accident-->

    <div *ngIf="manualCharges!=null && manualCharges.length>0">
      <section class="rental-time">
        <div class="selected-class-title mb-2">
          <fa-icon class="mr-2 selected-class-icon rounded-circle" [icon]="faCar"></fa-icon>
          {{ 'ManualCharges' | translate }}
        </div>

        <ng-container *ngFor="let item of manualCharges">
          <div class="manual-charge-title"> {{item.description}}</div>
          <ul class="list-group mb-4">
            <li class="list-group-item d-flex justify-content-between lh-condensed">
              <div>
                <h6 class="my-0">Charge</h6>
              </div>
              <span>{{item.amount | number : '1.2-2'}} {{currency}}</span>
            </li>
          </ul>
        </ng-container>
      </section>
    </div>

    <!--compensated items-->
    <div *ngIf="compensatedItems!=null && compensatedItems.length>0">
      <section class="rental-time">
        <div class="selected-class-title mb-2">
          <fa-icon class="mr-2 selected-class-icon rounded-circle" [icon]="faCar"></fa-icon>
          {{ 'CompensatedItems' | translate }}
        </div>

        <ng-container *ngFor="let item of compensatedItems">
          <div class="manual-charge-title"> {{item.serviceName}}</div>
          <ul class="list-group mb-4">
            <li class="list-group-item d-flex justify-content-between lh-condensed">
              <div>
                <h6 class="my-0">Charge</h6>
              </div>
              <span>{{item.compensationCharge | number : '1.2-2'}} {{currency}}</span>
            </li>
          </ul>
        </ng-container>
      </section>
    </div>
    <!--End Compensated-->
    <!--OutSide Working Hours charge-->
    <section class="rental-time" *ngIf="lstVehicleReservationCaseNonWorkingHoursChargeModel!=null&&lstVehicleReservationCaseNonWorkingHoursChargeModel.length>0">
      <div>
        <div class="selected-class-title mb-2">
          <fa-icon class="mr-2 selected-class-icon rounded-circle" [icon]="faCar"></fa-icon>
          {{'NonWorkingHoursCharge' | translate}}
        </div>

        <ul class="list-group mb-4" *ngFor="let item of lstVehicleReservationCaseNonWorkingHoursChargeModel">
          <li class="list-group-item d-flex justify-content-between lh-condensed">
            <div>
              <h6 class="my-0">
                {{item.name}}</h6>
            </div>
            <span>{{item.unitPrice | number : '1.2-2'}} {{currency}}</span>
          </li>
        </ul>


      </div>
    </section>
    <!--End OutSideWroking Hours charge-->
  </ng-container>

  <!--List Of Policies-->
  <ng-container *ngFor="let policy of lstPolicyReservationCaseModel">
    <div *ngIf="policy.isApply
    &&!policy.isFree
    &&policy.policyDefinitionId!=policyType.SecurityDepositPolicy&&policy.policyDefinitionId!=policyType.CancelationPolicy&&policy.unitPrice!=null"> <!--&&policy.unitPrice>0-->
      <section class="rental-time">
        <div class="selected-class-title mb-2">
          <fa-icon class="mr-2 selected-class-icon rounded-circle" [icon]="faCar"></fa-icon>
          {{ policyType[policy.policyDefinitionId] | translate }}
        </div>



        <ul class="list-group mb-4">
          <li class="list-group-item d-flex justify-content-between lh-condensed">
            <div>
              <h6 class="my-0">{{'Charge' | translate}}</h6>
            </div>
            <span>{{policy.unitPrice }} {{currency}}</span>
          </li>
        </ul>
      </section>
    </div>
  </ng-container>





  <ng-container
    *ngIf="(campaignsReservationCaseModel!=null &&  campaignsReservationCaseModel.discountScopeID==discountScope.TotalCharges)
  || (membershipModel!=null &&  membershipModel.discountScopeID==discountScope.TotalCharges)
  || (agencyEmployeeAllowedDiscountsModel!=null &&  agencyEmployeeAllowedDiscountsModel.discountScopeID==discountScope.TotalCharges)">
    <container-element>
      <section class="rental-time">
        <div class="selected-class-title mb-2">
          <fa-icon class="mr-2 selected-class-icon rounded-circle" [icon]="faCar"></fa-icon>
          {{ 'Discount' | translate }}
        </div>

        <!--Campaign disscount Total Charge-->
        <div
          *ngIf="campaignsReservationCaseModel!=null &&  campaignsReservationCaseModel.discountScopeID==discountScope.TotalCharges">
          <div class="manual-charge-title"> {{campaignsReservationCaseModel.campaignName}}</div>
          <ul class="list-group mb-4">
            <li class="list-group-item d-flex justify-content-between lh-condensed">
              <div>
                <h6 class="my-0">{{(campaignsReservationCaseModel.discount) | number : '1.2-2'}}%</h6>
              </div>
              <span>{{ subTotalBeforeDiscount | number : '1.2-2' }}
                {{currency}}</span>
              <!-- <span>{{( (campaignsReservationCaseModel.discount/100) *subTotal ) | number : '1.2-2' }} {{currency}}</span> -->
            </li>
          </ul>
        </div>


        <div *ngIf="membershipModel!=null &&  membershipModel.discountScopeID==discountScope.TotalCharges">
          <div class="manual-charge-title"> {{membershipModel.membershipName}}</div>
          <ul class="list-group mb-4">
            <li class="list-group-item d-flex justify-content-between lh-condensed">
              <div>
                <h6 class="my-0">{{(membershipModel.discountValue) | number : '1.2-2'}}%</h6>
              </div>
              <!-- <span>{{ subTotal | number : '1.2-2' }} {{currency}}</span> -->
              <span>{{  subTotalBeforeDiscount  | number : '1.2-2' }}
                {{currency}}</span>
            </li>
          </ul>
        </div>


        <div
          *ngIf="agencyEmployeeAllowedDiscountsModel!=null &&  agencyEmployeeAllowedDiscountsModel.discountScopeID==discountScope.TotalCharges">
          <div class="manual-charge-title"> {{'AgentDiscount' | translate}}</div>
          <ul class="list-group mb-4">
            <li class="list-group-item d-flex justify-content-between lh-condensed">
              <div>
                <h6 class="my-0">{{(agencyEmployeeAllowedDiscountsModel.discountPercentage) | number : '1.2-2'}}%</h6>
              </div>
              <!-- <span>{{ subTotal | number : '1.2-2' }} {{currency}}</span> -->
              <span>{{ subTotalBeforeDiscount  | number : '1.2-2' }} {{currency}}</span>
              <!-- <span>{{( (campaignsReservationCaseModel.discount/100) *subTotal ) | number : '1.2-2' }} {{currency}}</span> -->
            </li>
          </ul>
        </div>

      </section>




    </container-element>
  </ng-container>




  <!--Tax-->
  <ng-container *ngIf="true">
    <container-element>
      <section class="rental-time">
        <div class="selected-class-title mb-2">
          <fa-icon class="mr-2 selected-class-icon rounded-circle" [icon]="faCar"></fa-icon>
          Tax
        </div>
        <ul class="list-group mb-4">
          <li class="list-group-item d-flex justify-content-between lh-condensed">
            <div>
              <h6 class="my-0">{{taxPercent}}% x {{taxableAmount| number : '1.2-2'}} {{currency}}</h6>
            </div>
            <span>{{ totalTax | number : '1.2-2'}} {{currency}}</span>
          </li>
        </ul>
      </section>
    </container-element>
  </ng-container>


  <!--Voucher to be added (Not available at this stage)
      <hr />
    <section class="voucher">
      <div class="selected-class-title">
        <fa-icon class="mr-2 selected-class-icon rounded-circle" [icon]="faCar"></fa-icon>
        Voucher
      </div>
      <div class="input-group">
        <input formControlName="Voucher" id="Voucher"  type="text" class="form-control">
        <div class="input-group-append">
          <button type="button" class="btnLink check"><fa-icon class="ml-3" [icon]="faCheck"></fa-icon></button>
        </div>
      </div>
    </section>

    <hr />-->

  <!--Total-->
  <section class="total">
    <ul class="list-group mb-4">
      <li class="list-group-item d-flex justify-content-between lh-condensed">
        <div>
          <h6 class="my-0 pl-0 total-title">{{ 'Total' | translate }}</h6>
        </div>
        <span>{{totalPrice | number : '1.2-2'}} {{currency}}</span>

      </li>
    </ul>
  </section>


  <!--Payble Now-->
  <!--    <section class="payble-now">
      <h6 class="payble-title">  {{ 'PayableNow' | translate }}</h6>
      <span>{{chargeSummary.minDepositPrice}}{{currency}}</span>
    </section> -->

    <ng-container *ngIf="!isNoDeposiePolicy&&deposiePolicy!=null&&deposiePolicy.depositPolicyModel!=null&&deposiePolicy.depositPolicyModel.depositPolicyPaymentTypesID==depositPolicyPaymentTypes.PercentageOfTotalCharges&&viewBookingViewMode!=null&&(viewBookingViewMode==ViewBookingViewMode.Extend||viewBookingViewMode==ViewBookingViewMode.ModifyPickUp)">
      <section class="payble-now" *ngIf="(calculateTotalResult-vehicleReservationCaseResult.paid)>=0">
        <h6 class="payble-title">  {{ 'PayableNow' | translate }}</h6>
        <span>{{(calculateTotalResult-vehicleReservationCaseResult.paid)  | number : '1.2-2'}} {{currency}}</span>
      </section>

    </ng-container>

    <ng-container *ngIf="viewBookingViewMode==ViewBookingViewMode.Default && vehicleReservationCaseResult.caseStateID ==VehicleReservationState.Confirmed">
      <section class="payble-now" >
        <h6 class="payble-title">{{ 'SecurityDeposit' | translate }} <span class="payatpickup">({{'PayAtPickup' | translate}})</span></h6>
        <span>{{vehicleReservationCaseResult.securityDepositAmount | number : '1.2-2'}} {{currency}} </span>
      </section>

    </ng-container>


</div>
